import { Component, OnInit, Input } from '@angular/core';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationSteps } from "../../../../../applications/models/applications.models";
import { AuthService } from "../../../../../services/auth.service";
import { GISPointTypes } from "../../../../../common/models/well.model";
import { WellDirection } from "../../../../../form-controls/components/new-casing-plan/models/casing-plan.model";

@Component({
    selector: 'plat-location',
    templateUrl: './plat-location.component.html',
    styleUrls: ['./plat-location.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class PlatLocationComponent extends ApplicationSectionBaseComponent implements OnInit {

    readonly step: ApplicationSteps = ApplicationSteps.PlatLocation;
    directions = WellDirection;
    pointTypes = GISPointTypes;

    constructor(auth: AuthService) {
        super(auth);
    }

    ngOnInit() {
    }


    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }
}
